import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import Navigation from 'utils/navigation';

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const closeBtn = node.querySelector('.js-closeBtn');
  const popupToggles = node.querySelectorAll('.js-popupToggle');

  const navDrawer = Drawer(node);
  const navigation = new Navigation(node);

  /**
   * Functions
   */
  const init = () => {
    ctx.on('mobileNav:open', () => navDrawer.open());

    closeBtn.addEventListener('click', () => navDrawer.close());

    popupToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        if (e.target === toggle || Array.from(toggle.children).includes(e.target)) {
          e.preventDefault();

          toggle.classList.toggle('mobile-nav__popup-toggle--active');
          navigation.togglePopup(toggle);
        }
      });
    });
  };

  /**
   * Init
   */
  init();
});
